<template>
  <button
    type="button"
    @click="onBtnClick"
    :class="extraClasses"
    :data-toggle="dataToggle"
    :data-target="dataTarget"
    :disabled="disabled"
  >
    <slot></slot>
  </button>
</template>
<script>
import { mapGetters } from 'vuex';
import $ from 'jquery';

export default {
  name: 'PzButton',

  props: {
    extraClasses: String,
    dataToggle: String,
    dataTarget: String,
    callBack: {
      type: Function,
      default: () => {},
    },
    disabled: Boolean,
    params: Array,
    id: String,
    isPreventDefault: {
      type: Boolean,
      default: () => false,
    },
    isStopPropagation: {
      type: Boolean,
      default: () => false,
    },
    isClickOnce: {
      type: Boolean,
      default: () => false,
    },
    trackerInfo: {
      type: Object,
      default: () => null,
    },
  },

  data() {
    return {
      isClickedOnce: false,
    };
  },

  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
    }),

    hasLogin() {
      return !this.userInfo.unLogin;
    },
  },

  mounted() {
    this.$bus.once(this.id, () => {
      this.callBack.apply(this, this.params);
    });
  },

  methods: {
    onBtnClick(e) {
      if (this.isPreventDefault) {
        e.preventDefault();
      }
      if (this.isStopPropagation) {
        e.stopPropagation();
      }
      if (!this.hasLogin) {
        e.stopPropagation();
        $('#pz-login-modal').modal('show');
        this.$bus.emit(`setPzButtonId`, { pzButtonId: this.id });
      } else {
        this.callBack.apply(this, this.params);
        if (window._hmt && this.trackerInfo) {
          const { action, opt_label, opt_value } = this.trackerInfo;
          window._hmt.push(['_trackEvent', 'button', action, opt_label, opt_value]);
        }
      }
    },
  },
};
</script>
